import React from 'react'
import { useFormContext } from 'react-hook-form'

import { type InputValues } from '../../utils'

export const useTabulationQueryKey = () => {
  const { watch } = useFormContext<InputValues>()
  const [surveyId, brandGroupId, filter] = watch([
    'surveyId',
    'brandGroupId',
    'surveyFilter.filterGroups',
  ])

  return React.useMemo(
    () =>
      [
        'StrategyMemoEditPage_Tabulation',
        { surveyId, brandGroupId, filter },
      ] as const,
    [brandGroupId, filter, surveyId],
  )
}
